<template>
  <option value="NSW">NSW</option>
  <option value="VIC">VIC</option>
  <option value="QLD">QLD</option>
  <option value="SA">SA</option>
  <option value="WA">WA</option>
  <option value="TAS">TAS</option>
  <option value="NT">NT</option>
  <option value="ACT">ACT</option>
</template>
